module.exports = __webpack_public_path__ + "img/Aufgabenbeziehungen_Summand.8f6f2a9c.png";